

// In-memory cache
let ignoredSubstrings : string[] = []

export const defaultIgnoredSubstrings = [
  'chrome://',
  'chrome-extension://',
  'chrome-devtools://',
  'https://mail.google.com/chat',
  'meet.google.com/',
  'https://calendar.google.com/calendar/',
];

let normalizeRegexes: [string, string][] = [];

export const defaultNormalizeRegexes: [string, string][] = [
  ['(https://community.home-assistant.io/t/.*?/.*?)/.*', '$1'],
  ['(https://reddit.com/r/.*?/comments/.*?)/.*', '$1'],
  ['(https://google.com/maps/search/.*?)/.*', '$1'],
  ['(https://google.com/travel/flights/booking)\\?.*', '$1'],
  ['(https://zillow.com/.*)\\?.*', '$1'],
  ['(https://source.corp.google.com/.*?);.*', '$1'],
  ['(https://.*\\.google.com/.*)/u/./(.*)', '$1/$2'],
];

export function updateUrlNormalizationCache(ignored: string[], rules: [string, string][]) {
  ignoredSubstrings = ignored;
  normalizeRegexes = rules;
}


export function shouldIgnore(url: string): boolean {
  return ignoredSubstrings.some((s) => url.includes(s));
}

export function getIgnoredSubstrings() {
  return ignoredSubstrings;
}

export function getNormalizeUrlRegexes() {
  return normalizeRegexes;
}


